import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment";
import DateRangePicker from "../CustomComponents/DateRangePicker/DateRangePicker";
import { setDashboardDateRange } from "../../app/dashboardDateRangeSlice";

/** Dashboard routes only — Figma top-bar date pill */
function isDashboardPath(pathname) {
  if (!pathname) return false;
  const path = pathname.replace(/\/+$/, "") || "/";
  return (
    path === "/" ||
    path === "/dashboard" ||
    path.startsWith("/dashboard/")
  );
}

function HeaderDateRange() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { start, end } = useSelector((state) => state.dashboardDateRange);

  if (!isDashboardPath(pathname)) {
    return null;
  }

  const handleChange = (update) => {
    if (!Array.isArray(update)) return;
    const [s, e] = update;
    if (!s) return;
    const startM = moment(s).startOf("day");
    const endM =
      e && moment(e).isValid()
        ? moment(e).endOf("day")
        : startM.clone().endOf("day");
    const [from, to] = endM.isBefore(startM)
      ? [endM, startM.clone().endOf("day")]
      : [startM, endM];
    dispatch(
      setDashboardDateRange({
        start: from.toISOString(),
        end: to.toISOString(),
      })
    );
  };

  return (
    <div className="navbar-item header-topbar-date">
      <DateRangePicker
        id="header-topbar-date-range"
        startDate={new Date(start)}
        endDate={new Date(end)}
        onChange={handleChange}
        allowSingleDate={true}
        allowDateRange={true}
        forceDateLabel={true}
        className="header-topbar-date-picker"
      />
    </div>
  );
}

export default HeaderDateRange;
